'use client'

import { useEffect } from 'react'
import { useTranslations } from 'next-intl'

/** Page 500 personnalisée. Aucun détail technique n'est exposé au visiteur. */
export default function ErrorPage({ reset }: { error: Error; reset: () => void }) {
  const t = useTranslations()

  useEffect(() => {
    // La trace détaillée reste côté serveur (logs sans donnée personnelle).
  }, [])

  return (
    <div className="surface-aurora">
      <div className="container-site flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <p className="text-eyebrow text-accent-700 font-semibold uppercase">
          {t('errors.errorCode', { code: 500 })}
        </p>
        <h1 className="text-h1 text-ink-900 mt-4">{t('errors.serverErrorTitle')}</h1>
        <p className="text-lead text-text-muted mt-5 max-w-lg">
          {t('errors.serverErrorDescription')}
        </p>
        <button
          type="button"
          onClick={reset}
          className="bg-primary-500 hover:bg-primary-600 mt-10 inline-flex h-12 items-center rounded-full px-7 font-semibold text-white transition-colors"
        >
          {t('errors.serverErrorAction')}
        </button>
      </div>
    </div>
  )
}
